import React from "react";
import { Row, Col, Tabs, Select, Button, Input } from "antd";
import AdminMainLayout from '../AdminMainLayout';
import ENVIRONMENT from '../../../../environments';
import RoomsTable from '../../RoomsTable'
import axios from 'axios';
const { Option } = Select;

const { TabPane } = Tabs;

class AdminRoomsData extends React.Component {
  
  constructor(props){
    super(props)

    this.state = {
      admin_qa_count: null,
      admin_view_count: null,
      failed_aborted_count: null,
      being_fixed_count: null,
      enqueued_count: null,
      artist_review_count: null,
      customers_names: [],
      filter_product_id: "",
    };  
  }

  componentDidMount(){
    this.populateCustomersList();  
  }

  populateCustomersList = () => {
    axios.post(ENVIRONMENT.CUSTOMER_GET_BATCH, {
      })
        .then(res => {
          var customers_names = [];
          for (let i = 1; i <= (res.data).length; i++) {
            customers_names.push(res.data[i - 1]['customer_username']);

          }
          
          this.setState({
            customers_names: customers_names
          })
        })
    
  }

  setAdminQACount = (value) => {
    this.setState({
      admin_qa_count: value
    });
  }

  setAdminViewCount = (value) => {
    this.setState({
      admin_view_count: value
    });
  }

  setFailedAndAbortedCount = (value) => {
    this.setState({
      admin_rejected_count: value
    });
  }

  setBeingFixedCount = (value) => {
    this.setState({
      being_fixed_count: value
    });
  }

  setEnqueuedCount = (value) => {
    this.setState({
      enqueued_count: value
    });
  }

  setArtistReviewCount = (value) => {
    this.setState({
      artist_review_count: value
    });
  }


  onFilterIdChange = e => {
    this.setState({
      filter_product_id: e.target.value
    });
  }

  applyCustomerFilter = () => {
    window.location.href = "/admin_rooms?customer=" + this.state.customer_username_filter
  }

  applyIdFilter = () => {
    window.location.href = "/admin_rooms/" + this.state.filter_product_id
  }

  render() {
    const { customer_username_filter } = this.state;
    const { size } = this.state;
    return (
      <AdminMainLayout selected={"3"}>
        <Row style={{marginTop: 24}} gutter={24}>
          <Col span={2}>
            <p style={{margin: 3, fontSize: 16}}>
              <b>Go to ID:</b>
            </p>
          </Col>
          <Col span={4}>
            <Input type='number' min='1' style={{ width: "100%" }} onChange={this.onFilterIdChange} />
          </Col>
          <Col span={4}>
                <Button type="primary" onClick={() => this.applyIdFilter()} disabled={(this.state.filter_product_id == "")}>Submit</Button>
          </Col>
        </Row>
        <Tabs defaultActiveKey="1" size={size} tabBarStyle={{textAlign: 'center'}} animated={false}>
          <TabPane tab={(this.state.admin_qa_count==null)?"QA Pending":"QA Pending (" + this.state.admin_qa_count + ")"} key="1">
            <RoomsTable
              customer_username_filter={customer_username_filter}
              state="admin_qa"
              setCount={this.setAdminQACount}
            />
          </TabPane>
          <TabPane tab={(this.state.admin_view_count==null)?"Customer QA Pending":"Customer QA Pending (" + this.state.admin_view_count + ")"} key="2">          
            <RoomsTable
              customer_username_filter={customer_username_filter}
              state="admin_view"
              setCount={this.setAdminViewCount}
            />
          </TabPane>
          <TabPane tab={(this.state.being_fixed_count==null)?"Being Fixed":"Being Fixed (" + this.state.being_fixed_count + ")"} key="4">
            <RoomsTable
              customer_username_filter={customer_username_filter}
              state="being_fixed"
              setCount={this.setBeingFixedCount}
            />
          </TabPane>
          <TabPane tab={(this.state.artist_review_count==null)?"Artist Review":"Artist Review (" + this.state.artist_review_count + ")"} key="5">
            <RoomsTable
              customer_username_filter={customer_username_filter}
              state="artist_review_for_admin"
              setCount={this.setArtistReviewCount}
            />
            </TabPane>
          <TabPane tab={(this.state.enqueued_count==null)?"Enqueued":"Enqueued (" + this.state.enqueued_count + ")"} key="6">
            <RoomsTable
              customer_username_filter={customer_username_filter}
              state="enqueued"
              setCount={this.setEnqueuedCount}
            />
          </TabPane>
          <TabPane tab={(this.state.failed_aborted_count==null)?"Failed & Aborted":"Failed & Aborted (" + this.state.failed_aborted_count + ")"} key="7">
            <RoomsTable
              customer_username_filter={customer_username_filter}
              state="failed_aborted"
              setCount={this.setFailedAndAbortedCount}
            />
          </TabPane>
        </Tabs>
      </AdminMainLayout>
    );
  }
}

export default AdminRoomsData;